/**
 * Black Tulip v3 — buy box.
 * Size chips drive the hidden variant id. The Add to Bag button is disabled
 * until a real variant is selected, and can never fire against a null one.
 *
 * It also drives the Notify Me slot. Until 29 September that was Klaviyo's
 * back-in-stock trigger, which nothing drove until 16 September; since then it
 * is Shopify's own customer form (A16, see the Liquid), and the history below
 * is why the size still goes into ?variant= in the address bar. Klaviyo reads the selected variant out of [name="id"] and
 * re-reads it on that input's `change` event — an event a <select> fires for
 * itself and a hidden <input> written by script does not. So Klaviyo's idea of
 * what the shopper had chosen was whatever it read on load: nothing, which it
 * takes for unavailable. Two consequences, both of them Yash's find: the
 * trigger offered to notify a shopper about a product with every size in
 * stock, and once a size WAS chosen the modal it opened was still about no
 * variant in particular.
 */
(function () {
  'use strict';
  function init(root) {
    var chips = root.querySelectorAll('[data-v3-size]');
    var idInput = root.querySelector('[data-v3-variant-id]');
    var atc = root.querySelector('[data-atc="inline"]');
    var pick = root.querySelector('[data-v3-pick]');
    var bar = document.querySelector('[data-atc-bar]');
    var price = root.querySelector('[data-v3-price]');
    // The Notify Me slot, and the hidden tags field of its form, which sits
    // after the add-to-cart form (a form cannot nest), hence document-wide.
    var bis = root.querySelector('[data-v3-bis-slot]');
    var bisTags = document.querySelector('[data-v3-bis-tags]');
    if (!chips.length || !idInput || !atc) return;

    // Writing .value never fires an event. Klaviyo listens for one, so it is
    // dispatched by hand; `bubbles` because Klaviyo delegates from the form.
    function announce() {
      try {
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        // IE-era fallback. Cheap, and a thrown constructor here would take the
        // whole selection with it.
        var ev = document.createEvent('HTMLEvents');
        ev.initEvent('change', true, false);
        idInput.dispatchEvent(ev);
      }
    }

    // The back-in-stock trigger is in the DOM from load so that Klaviyo binds to
    // it rather than injecting one of its own; it is shown only once a real size
    // has been chosen AND that size has nothing to sell. Before a size is chosen
    // there is no question to answer, so it stays off.
    //
    // A data attribute on the wrapper, not `hidden` on the button: `hidden` is
    // an attribute Klaviyo recognises and removes, and the button is an element
    // it is entitled to replace. Nothing it does can reach this.
    function showBis(on) {
      if (!bis) return;
      bis.dataset.state = on ? 'on' : 'off';
    }

    // NOTIFY ME (A16). The size she asked about goes into the customer's tags —
    // the variant id, and a readable handle-and-size — so Yash can email
    // everyone waiting for exactly that pair from Shopify Email.
    function setBisTags(match) {
      if (!bisTags) return;
      var tags = ['back-in-stock'];
      if (match) {
        tags.push('bis-' + match.id);
        var size = String(match.option1 || '').replace(/[^0-9A-Za-z]+/g, '-').replace(/^-+|-+$/g, '');
        if (bisTags.dataset.handle && size) tags.push('bis-' + bisTags.dataset.handle + '-' + size);
      }
      bisTags.value = tags.join(', ');
      // A new size after a thank-you asks again.
      if (bisAsk) bisAsk.hidden = false;
      if (bisDone) bisDone.hidden = true;
    }

    /**
     * Tell Klaviyo WHICH size she asked about.
     *
     * For a sold-out size we deliberately leave [name="id"] empty — D11, so the
     * form can never post a variant that cannot be bought. But Klaviyo reads
     * that same field to decide what to subscribe her to, and an empty one
     * sends it back to the product's first variant. She would tap 7/40, and be
     * told when 3/36 returns.
     *
     * So the choice is published where Klaviyo also looks and where the store
     * already puts it: ?variant= in the address bar. replaceState rather than
     * pushState, because picking a size is not a page she should have to press
     * Back through.
     */
    function publishVariant(id) {
      if (!window.history || !history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (id) url.searchParams.set('variant', id);
        else url.searchParams.delete('variant');
        history.replaceState({}, '', url.toString());
      } catch (e) {
        // A URL the browser will not parse is not worth losing the selection over.
      }
    }

    // PRE-ORDER — W-20261019-2, the rule in snippets/v3-preorder.liquid,
    // applied to the chosen size from the variants payload: a ship-by date not
    // past, else no date ("to follow"). Dates compared as ISO strings against
    // today in the shop's calendar (Europe/London).
    // It also sets the line property the form posts, the button label, and
    // takes the computed "Arrives by" row out for a pre-order size.
    var preorder = root.querySelector('[data-v3-preorder]');
    var poProp = root.querySelector('[data-v3-po-prop]');
    var arrives = root.querySelector('[data-v3-arrives]');
    var poWarn = root.querySelector('[data-v3-preorder-missing]');
    var poScopes = root.querySelectorAll('[data-v3-po-scope]');
    function poState(match) {
      // match.po is the server's whole rule (flag on, no stock, continues
      // selling: Yash's review, Sumit 20 Oct); only the date is decided here.
      if (!match || !match.po || !match.available) return null;
      // Today in the shop's calendar (Europe/London), as Liquid and quick add
      // read it — not the shopper's, or a shopper abroad late in the day
      // could lose the date and post a different property for the same size.
      var today;
      try { today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' }).format(new Date()); }
      catch (e) { var d = new Date(); today = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
      if (match.preorder && match.preorder_iso && match.preorder_iso >= today) {
        return { mode: 'from', date: match.preorder };
      }
      return { mode: 'tbc' };
    }
    function fill(tpl, st) {
      return String(tpl || '').replace('__DATE__', st.date || '');
    }
    function showPreorder(match) {
      var st = poState(match);
      if (preorder) {
        var tpl = st && st.mode === 'from' ? preorder.dataset.line : '';
        if (tpl) { preorder.textContent = fill(tpl, st); preorder.hidden = false; }
        else { preorder.textContent = ''; preorder.hidden = true; }
      }
      if (poProp) {
        if (st) {
          poProp.value = st.mode === 'from' ? fill(poProp.dataset.from, st) : (poProp.dataset.tbc || '');
          poProp.disabled = false;
        } else {
          poProp.value = '';
          poProp.disabled = true;
        }
      }
      if (arrives) {
        if (st) arrives.setAttribute('data-v3-po', ''); else arrives.removeAttribute('data-v3-po');
      }
      // The express line drops its same-day clause beside a pre-order size.
      for (var q = 0; q < poScopes.length; q++) {
        if (st) poScopes[q].setAttribute('data-v3-po', ''); else poScopes[q].removeAttribute('data-v3-po');
      }
      // Theme editor only (the element is rendered nowhere else).
      if (poWarn) {
        // po carries the whole rule, so "flagged but cannot be bought" reads
        // the raw flag, which the payload carries in the theme editor only.
        var warn = match && match.po_flag === true && !match.available ? poWarn.dataset.unsellable :
                   st && st.mode === 'tbc' ? poWarn.dataset.missing : '';
        poWarn.textContent = warn || '';
        poWarn.hidden = !warn;
      }
      return st;
    }
    var failed = root.querySelector('[data-v3-add-failed]');

    var variants = [];
    var el = root.querySelector('[data-v3-variants]');
    if (el) { try { variants = JSON.parse(el.textContent); } catch (e) { variants = []; } }

    function select(value) {
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option1 === value) { match = variants[i]; break; }
      }
      for (var j = 0; j < chips.length; j++) {
        chips[j].setAttribute('aria-pressed', chips[j].dataset.v3Size === value ? 'true' : 'false');
      }
      if (pick) pick.textContent = value.replace('/', ' · EU ');
      // The price follows the choice. Liquid states the resolved variant's
      // price on load; without this the gift card's two denominations both
      // showed the cheaper one once the shopper picked the dearer.
      // The price follows the choice, and so does what it was reduced from.
      // These write the two inner elements rather than the container, because
      // writing textContent onto [data-v3-price] would delete the <s> the
      // Liquid put there — correct on load and gone on the first size pressed.
      if (price && match && match.price) {
        var now = price.querySelector('[data-v3-now]');
        if (now) now.textContent = match.price; else price.textContent = match.price;
        var was = price.querySelector('[data-v3-was]');
        if (was) {
          if (match.was) { was.textContent = match.was; was.hidden = false; }
          else { was.textContent = ''; was.hidden = true; }
        }
      }
      var po = showPreorder(match);
      if (failed) { failed.hidden = true; failed.textContent = ''; }
      // A size is chosen: the bar stops being the way to the sizes and becomes
      // the real submit, carrying the same state as the inline button below.
      if (bar && bar.hasAttribute('data-v3-choose')) {
        bar.removeAttribute('data-v3-choose');
        bar.type = 'submit';
      }
      if (match && match.available) {
        idInput.value = match.id;
        atc.disabled = false;
        atc.removeAttribute('aria-disabled');
        atc.textContent = (po ? atc.dataset.labelPreorder : atc.dataset.labelAdd) || atc.textContent;
        // The bar is a real submit bound to the same form, so it carries the
        // same state. Mirroring only the LABEL would leave an enabled-looking
        // control that fires against a null variant, which is the fault D11
        // exists to prevent.
        if (bar) { bar.textContent = atc.textContent; bar.disabled = false; bar.removeAttribute('aria-disabled'); }
        showBis(false);
        publishVariant(match.id);
      } else {
        // No resolvable, purchasable variant for this size. Liquid disables the
        // chip in that case so this branch should be unreachable — but without
        // it, a stale id and an enabled button survive from the last selection,
        // and the customer buys the size they clicked away from.
        idInput.value = '';
        atc.disabled = true;
        atc.setAttribute('aria-disabled', 'true');
        atc.textContent = atc.dataset.labelSoldOut || atc.textContent;
        if (bar) { bar.textContent = atc.textContent; bar.disabled = true; bar.setAttribute('aria-disabled', 'true'); }
        // Only when the size exists and is out of stock. `match === null` means
        // the size is not made in this style at all, and there is nothing to be
        // told about.
        showBis(!!match);
        setBisTags(match);
        // Her actual choice, in the address bar: Shopify reloads the page to it
        // after a Notify Me request, so the same size is still chosen. The
        // add-to-cart form still cannot post it — idInput was cleared above.
        publishVariant(match ? match.id : null);
      }
      announce();
    }

    /*
     * A SIZE THAT SELLS OUT BETWEEN THE PAGE AND THE PRESS — Q08, 26 September.
     *
     * The form posted natively, so when the last pair of a size went while she
     * was looking at it, the answer was Shopify's bare error page, or nothing
     * at all. Now the same form goes to /cart/add.js:
     *
     *   · success — on to the bag, exactly where the native post went;
     *   · Shopify says the size is SOLD OUT — the size is marked sold out
     *     where she is (chip, button, back-in-stock), and Sumit's sentence says
     *     what happened, as an alert so a screen reader hears it at once;
     *   · anything else, or no fetch at all — the native post, as before. A
     *     network error must never cost her the add.
     *
     * Both submits — the inline button and the sticky bar, bound by form= —
     * fire this one event, so both are covered.
     */
    var form = document.getElementById('v3-add-to-cart');
    if (form && failed && window.fetch && window.FormData) {
      var sending = false;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (sending) return;
        sending = true;
        failed.hidden = true;
        failed.textContent = '';
        var chosen = null;
        for (var c = 0; c < chips.length; c++) {
          if (chips[c].getAttribute('aria-pressed') === 'true') { chosen = chips[c]; break; }
        }
        var native = function () { sending = false; form.submit(); };
        var url = (form.getAttribute('action') || '/cart/add').replace(/\/$/, '') + '.js';
        fetch(url, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        }).then(function (r) {
          return r.json().then(function (b) { return { r: r, b: b }; },
                              function () { return { r: r, b: {} }; });
        }).then(function (x) {
          if (x.r.ok) { window.location.href = form.getAttribute('data-cart-url') || '/cart'; return; }
          var why = String((x.b && (x.b.description || x.b.message)) || '');
          if (x.r.status !== 422 || !/sold out/i.test(why)) { native(); return; }
          sending = false;
          var value = chosen ? chosen.dataset.v3Size : null;
          if (value) {
            for (var v = 0; v < variants.length; v++) {
              if (variants[v].option1 === value) variants[v].available = false;
            }
            if (!chosen.hasAttribute('data-v3-soldout')) {
              chosen.setAttribute('data-v3-soldout', '');
              var sr = document.createElement('span');
              sr.className = 'v3-sr';
              sr.textContent = ', ' + (atc.dataset.labelSoldOut || '');
              chosen.appendChild(sr);
            }
            select(value);                     // button to Sold out, back-in-stock on
          }
          var uk = value ? value.split('/')[0] : '';
          failed.textContent = uk && failed.dataset.withSize
            ? failed.dataset.withSize.replace('__SIZE__', uk)
            : (failed.dataset.noSize || '');
          failed.hidden = false;
        }).catch(native);
      });
      // BACK FROM THE BAG. Success leaves `sending` set on purpose — a second
      // press during the navigation must not add twice — but the browser keeps
      // this page whole in its back/forward cache, flag and all. She pressed
      // Back to add a second size and every press after that did nothing: no
      // request, no navigation, no message. Found in review, 27 September. A
      // restored page is a new visit to the same page, so it starts unsent.
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) sending = false;
      });
    }

    /*
     * BEFORE A SIZE IS CHOSEN, THE BAR TAKES HER TO THE SIZES — Sumit,
     * 27 September. On a phone the photograph keeps its full width, so the
     * size chips start below the first screen and the sticky bar is the one
     * control on it. It was greyed out until a size was picked, and a tap did
     * nothing. In that state the Liquid renders it type="button" with
     * data-v3-choose, so it cannot post the form (D11). A tap brings the size
     * group into view and puts focus on the first size that can be bought, so
     * a screen reader lands where the choice is made. select() turns it into
     * the submit on the first size.
     */
    if (bar && bar.hasAttribute('data-v3-choose')) {
      bar.addEventListener('click', function (e) {
        if (!bar.hasAttribute('data-v3-choose')) return;   // a size since: it submits
        e.preventDefault();
        var first = null;
        for (var f = 0; f < chips.length; f++) {
          if (!chips[f].hasAttribute('data-v3-soldout')) { first = chips[f]; break; }
        }
        first = first || chips[0];
        var group = (first.closest && first.closest('.v3-grp')) || first.parentNode;
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try { group.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' }); }
        catch (err) { group.scrollIntoView(); }
        try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
      });
    }

    /*
     * AFTER A NOTIFY ME REQUEST. Shopify's customer form posts and reloads the
     * page with ?customer_posted=true, and the browser keeps the form's own
     * fragment, #v3-bis-form. The footer sign-up is a customer form too and
     * reloads with the same parameter, so the fragment is what says the
     * request was this one. The size is still in ?variant=, so its chip is the
     * marked one; the slot is opened on the thank-you, and focus goes to it,
     * because she is at the top of a fresh page she did not ask for.
     */
    var bisDone = bis && bis.querySelector('[data-v3-bis-done]');
    var bisAsk = bis && bis.querySelector('[data-v3-bis-ask]');
    var bisPosted = false;
    try {
      bisPosted = window.location.hash === '#v3-bis-form' &&
        new URLSearchParams(window.location.search).get('customer_posted') === 'true';
    } catch (e) { bisPosted = false; }
    if (bisPosted && bisDone) {
      if (bisAsk) bisAsk.hidden = true;
      bisDone.hidden = false;
      showBis(true);
      try { bisDone.scrollIntoView({ block: 'center', behavior: 'auto' }); } catch (e) { bisDone.scrollIntoView(false); }
      try { bisDone.focus({ preventScroll: true }); } catch (e) { bisDone.focus(); }
    }

    for (var k = 0; k < chips.length; k++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          // `disabled` stops the browser dispatching at all, so this only ever
          // guarded against a chip something else had disabled. A sold-out chip
          // carries aria-disabled now and MUST be allowed through: selecting it
          // is how she gets to ask about it. select() refuses to set a variant
          // id for it, which is where D11 is actually enforced.
          if (chip.disabled) return;
          select(chip.dataset.v3Size);
        });
      })(chips[k]);
    }
  }
  /*
   * THE COLOURWAY SHE IS ON HAS TO BE VISIBLE. 18 September.
   *
   * The chip row keeps the same order on every colourway of a style, which is
   * what makes it navigable — tap the third chip, land on a page where the
   * third chip is the marked one. The cost is that the marked chip is wherever
   * the alphabet puts it, and Arbi has eleven: on a 390px phone only seven fit,
   * so on Arbi Sand, Sage Green, Leopard and Light Grey the one chip that says
   * "you are here" started off-screen, on a row with no visible marker at all.
   *
   * Hoisting self to the front would fix it and break the ordering that makes
   * the row worth having. So the row is scrolled instead, and only when it
   * needs to be: `nearest` leaves a chip that is already visible where it is,
   * so the eight styles that fit never move.
   *
   * `block: 'nearest'` as well, or the browser scrolls the PAGE to bring the
   * row into view on load, which would drop the shopper below the photograph.
   */
  function revealCurrentColourway(root) {
    var here = root.querySelector('.v3-pdp__sws [aria-current]');
    if (!here || !here.scrollIntoView) return;
    var row = here.closest('.v3-pdp__sws');
    if (!row || row.scrollWidth <= row.clientWidth + 1) return;
    try { here.scrollIntoView({ inline: 'center', block: 'nearest' }); }
    catch (e) { here.scrollIntoView(false); }
  }

  /* THE STICKY BAR HANDS OVER TO THE REAL BUTTON — 23 September.

     Sameer, round 5: "Due to the sticky ATC on the PDP, there is a point during
     scrolling where the page CTA and sticky CTA overlap, making it look like an
     error." Measured at 390x844: the two boxes intersect for scrollY 229-336, a
     108px window (52 + 56, the geometrically unavoidable width when nothing
     hides either control). The sticky one is fixed at z-index 40 and the
     in-page one is static, so the sticky one is painted ON TOP: at scrollY 281
     elementFromPoint at the in-page button's own centre returns the bar. The
     tail of the window is what he photographed — at scrollY 320 you see one
     contiguous mass carrying TWO identical labels 37px apart. It is not
     phone-only either: the bar shows to 899px, so the same window exists at 768
     and 834.

     WHY BOTH MARGINS, AND WHY NEITHER NUMBER IS TYPED. The obvious version of
     this — shrink the root by the bar's height alone — was built and swept
     before it was written down, and it opens a hole worse than the seam it
     closes: 19 consecutive scroll positions at 390x844 with the bar already
     hidden and ZERO clear pixels of the in-page button, because .v3-hd-sticky
     is 57px tall at z-index 40 and the button passes entirely behind it before
     the observer stops believing it is on screen. A 57px stretch with no Add to
     Bag anywhere is the same class of fault as the one being fixed.

     So the root is shrunk at BOTH ends — by the header at the top and by the
     bar at the bottom — and both figures are read from the things themselves.
     --v3-hd-h already exists for exactly this reason and says so: "The sticky
     buy box offsets against this, so the two cannot drift apart." Typing 57 and
     56 here would be the third instance in this repo of a number that silently
     decoupled from the thing it describes.

     display:none, not opacity and not transform: the bar is a real submit bound
     by form="v3-add-to-cart", and a hidden-but-present submit stays in the tab
     order. It is correct to take it out precisely because it goes only when the
     real button is on screen and focusable.

     Its own block, outside init(): init() returns early unless the page has
     size chips, and the four accessory product pages render both controls and
     overlap identically while having none. */
  function px (v, fallback) {
    var n = parseFloat(v);
    return isFinite(n) && n > 0 ? n : fallback;
  }

  function wireStickyHandover() {
    var bar = document.querySelector('[data-atc-bar]');
    var inline = document.querySelector('[data-atc="inline"]');
    if (!bar || !inline) return;
    if (typeof IntersectionObserver === 'undefined') return;  // bar stays up

    var head = document.querySelector('.v3-hd-sticky');
    var headH = px(getComputedStyle(document.documentElement)
      .getPropertyValue('--v3-hd-h'), head ? head.getBoundingClientRect().height : 57);
    var barH = px(bar.getBoundingClientRect().height, 56);

    /* The +1 is a guard band, and it was measured rather than added for luck.
       With the top margin at exactly the header height there is ONE pixel of
       scroll — scrollY 968 in the fixture — where the bar has already gone and
       the button's last row has just passed behind the header, so neither is
       usable. It is the observer's own boundary rounding at threshold 0 and it
       survives a 30ms wait, so it is real rather than a measuring artifact.
       Taking the root one pixel further in makes the bar come back one pixel
       earlier and closes it. One pixel of overlap is not a usable button
       anyway, so nothing is lost by handing over a pixel sooner. */
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        bar.setAttribute('data-state', entries[i].isIntersecting ? 'off' : 'on');
      }
    }, { rootMargin: (-(headH + 1)) + 'px 0px ' + (-(barH + 1)) + 'px 0px', threshold: 0 });

    io.observe(inline);
  }

  /* A KEYBOARD STOP ON THE RAIL SCROLLS CLEAR OF THE FADES — 26 September.
     The rail's two fades paint over the chips, and scroll-padding-inline alone
     did not keep focus out from under them: Chrome's focus scroll moves a chip
     only when it lies ENTIRELY outside the padded area, and then centres it. A
     chip partly inside that band — 23px from the edge, fully in the scrollport —
     was not moved at all, and its ring sat 10px under the fade. Measured across
     360-767px, 386 of 408 widths still stopped focus under a fade. `nearest`
     honours the padding exactly and moves the row only as far as it must.

     :focus-visible only, so a tap or a click never scrolls the row under her
     finger, and nothing here runs on load — that is revealCurrentColourway. */
  function keepFocusedChipClear(root) {
    var row = root.querySelector('.v3-pdp__sws');
    if (!row) return;
    row.addEventListener('focusin', function (e) {
      var chip = e.target;
      try {
        if (!chip.matches(':focus-visible')) return;
        chip.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      } catch (err) { /* no :focus-visible support: leave the row alone */ }
    });
  }

  /* THE PHOTOGRAPH ROW — gallery C, Sumit, 1 October 2026. Below 900px the
     photographs are one row swiped sideways (assets/v3-pdp.css does the
     swiping with scroll-snap), and the "1 / 7" on the first frame follows the
     swipe. From 900px the row becomes the desktop gallery (W-20261007-1,
     Sumit, 7 October 2026): one main photograph and a rail of thumbnails
     (assets/v3-pdp.css); the stylesheet hides the counter, and the thumbnail
     code below runs instead.

     The frame counted is the one nearest the row's left padding, where
     scroll-snap parks it. At the far end of the row the last frame cannot
     reach that edge, so the end of the scroll counts as the last frame.

     A KEYBOARD STOP ONLY WHILE IT SCROLLS. A row that scrolls must be
     reachable without a pointer, so it takes tabindex 0 and a name (the style
     name, already in the page, so no new wording). On the desktop grid there
     is nothing to scroll, and the same attribute would be a tab stop that does
     nothing, so it is set and removed by whether the row overflows, re-checked
     when the window changes size. */
  function wireGallery(root) {
    var track = root.querySelector('[data-v3-media-track]');
    if (!track) return;
    var count = root.querySelector('[data-v3-media-count]');
    var frames = track.querySelectorAll('.v3-media__img');
    var n = frames.length;
    var queued = false;

    function current() {
      var room = track.scrollWidth - track.clientWidth;
      if (room <= 1) return 0;
      if (track.scrollLeft >= room - 2) return n - 1;
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var edge = track.getBoundingClientRect().left + pad;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < n; i++) {
        var d = Math.abs(frames[i].getBoundingClientRect().left - edge);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }
    function paint() {
      queued = false;
      if (count && n > 1) count.textContent = (current() + 1) + ' / ' + n;
    }
    function reach() {
      if (track.scrollWidth > track.clientWidth + 1) {
        track.setAttribute('tabindex', '0');
        track.setAttribute('role', 'group');
        if (track.dataset.label) track.setAttribute('aria-label', track.dataset.label);
      } else {
        track.removeAttribute('tabindex');
        track.removeAttribute('role');
        track.removeAttribute('aria-label');
      }
    }
    track.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(paint);
    }, { passive: true });
    window.addEventListener('resize', function () { reach(); paint(); });
    reach();

    /* THE DESKTOP GALLERY (W-20261007-1, Sumit, 7 October 2026). From 900px
       one photograph is on show and the rest wait: a click on a thumbnail
       (snippets/v3-product-media.liquid) puts that photograph on show, sets
       aria-pressed on the thumbnails, and remembers which in activeIdx, which
       is where the open-full-screen button starts. The stylesheet does the
       showing and hiding from [data-active] on a photograph and
       [data-v3-has-active] on the track; the first photograph is on show
       before this runs. A photograph still held back (the lead-first release
       below) is released the moment it is chosen. Arrow Up and Down, Home and
       End move along the rail and show that photograph; the arrows on the photograph step through them. Below 900px none of this shows, but the
       attributes are kept in step anyway so a window that is resized lands on
       the right photograph. */
    var wide = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;
    function isWide() { return !!(wide && wide.matches); }
    var rail = root.querySelector('.v3-media__thumbs');
    var thumbs = rail ? rail.querySelectorAll('[data-v3-thumb]') : [];
    var activeIdx = 0;
    function show(i) {
      if (i < 0 || i >= n) return;
      activeIdx = i;
      track.setAttribute('data-v3-has-active', '');
      for (var k = 0; k < n; k++) {
        if (k === i) frames[k].setAttribute('data-active', '');
        else frames[k].removeAttribute('data-active');
      }
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].setAttribute('aria-pressed', t === i ? 'true' : 'false');
      }
      unhold(frames[i]);
      keep(thumbs[i]);
    }
    /* The rail scrolls with no scrollbar (a classic 10px one cut every 72px
       thumbnail, Yash's review of #185), so it fades at whichever end has
       more, and the chosen thumbnail is scrolled into the rail — the rail
       only, never the page. */
    function ends() {
      if (!rail) return;
      var more = rail.scrollTop + rail.clientHeight < rail.scrollHeight - 1;
      if (more) rail.setAttribute('data-v3-more', ''); else rail.removeAttribute('data-v3-more');
      if (rail.scrollTop > 1) rail.setAttribute('data-v3-less', ''); else rail.removeAttribute('data-v3-less');
    }
    function keep(b) {
      if (!b || !rail || !isWide()) return;
      var r = b.getBoundingClientRect(), box = rail.getBoundingClientRect();
      if (r.top < box.top) rail.scrollTop -= box.top - r.top;
      else if (r.bottom > box.bottom) rail.scrollTop += r.bottom - box.bottom;
      ends();
    }
    var steps = root.querySelectorAll('[data-v3-step]');
    if (thumbs.length > 1) {
      show(0);
      ends();
      rail.addEventListener('scroll', ends, { passive: true });
      window.addEventListener('resize', ends);
      for (var s = 0; s < steps.length; s++) {
        steps[s].hidden = false;
        steps[s].addEventListener('click', function () {
          var d = parseInt(this.getAttribute('data-v3-step'), 10);
          show((activeIdx + d + n) % n);
        });
      }
      rail.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-v3-thumb]') : null;
        if (b) show(parseInt(b.getAttribute('data-v3-thumb'), 10));
      });
      rail.addEventListener('keydown', function (e) {
        var at = Array.prototype.indexOf.call(thumbs, document.activeElement);
        if (at < 0) return;
        var to = e.key === 'ArrowDown' ? at + 1 : e.key === 'ArrowUp' ? at - 1 :
                 e.key === 'Home' ? 0 : e.key === 'End' ? thumbs.length - 1 : -1;
        if (to < 0 || to >= thumbs.length) return;
        e.preventDefault();
        thumbs[to].focus();
        show(to);
      });
    }

    /* FULL SCREEN ON TAP (W-20261003-2, Sumit, 3 October 2026). A tap or
       click on a photograph opens it full screen at that photograph; the open
       button (snippets/v3-product-media.liquid) opens it at the one on screen.
       The viewer's script and stylesheet are fetched here on the first tap and
       never before, so the page itself carries nothing for it. A tap that
       becomes a sideways swipe never fires click, so swiping the row is
       unchanged. */
    var media = root.querySelector('[data-v3-media]');
    var opener = root.querySelector('[data-v3-zoom-open]');
    var zoomLoad = null;
    function loadZoom() {
      if (zoomLoad) return zoomLoad;
      zoomLoad = new Promise(function (resolve, reject) {
        var waiting = 2;
        function done() { if (--waiting === 0) resolve(); }
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = media.getAttribute('data-v3-zoom-css');
        css.onload = done;
        css.onerror = done;
        document.head.appendChild(css);
        var js = document.createElement('script');
        js.src = media.getAttribute('data-v3-zoom-js');
        js.onload = done;
        js.onerror = function () { zoomLoad = null; reject(); };
        document.head.appendChild(js);
      });
      return zoomLoad;
    }
    function zoom(i, from) {
      loadZoom().then(function () {
        if (window.v3Zoom) window.v3Zoom.open(media, i, from);
      }, function () {});
    }
    if (media && media.getAttribute('data-v3-zoom-js') && typeof HTMLDialogElement !== 'undefined') {
      track.addEventListener('click', function (e) {
        var img = e.target && e.target.closest ? e.target.closest('.v3-media__img') : null;
        if (!img) return;
        var i = Array.prototype.indexOf.call(frames, img);
        if (i >= 0) zoom(i, opener || img);
      });
      /* The viewer closing on the desktop gallery (assets/v3-zoom.js): the
         photograph last viewed becomes the main photograph and its thumbnail
         is pressed. On a phone the viewer scrolls the row itself. */
      media.addEventListener('v3zoomclose', function (e) {
        if (isWide() && thumbs.length > 1 && e.detail) show(e.detail.index);
      });
      if (opener) {
        opener.hidden = false;
        opener.addEventListener('click', function () { zoom(isWide() ? activeIdx : current(), opener); });
      }
    }

    /* THE LEAD FIRST (page speed, 2 October 2026). Photographs 2 onwards
       arrive with their files in data-v3-src / data-v3-srcset
       (snippets/v3-product-media.liquid), because the second one peeks in on
       screen and the browser would otherwise fetch it alongside the lead.
       They are moved across once the lead has loaded or failed, or after 4
       seconds at most; srcset before src, so the browser chooses from the
       candidates rather than starting on the fallback. They keep
       loading="lazy", so frames far down the row still wait to be near. */
    var lead = frames[0];
    var released = false;
    function unhold(f) {
      if (f.hasAttribute('data-v3-srcset')) {
        f.setAttribute('srcset', f.getAttribute('data-v3-srcset'));
        f.removeAttribute('data-v3-srcset');
      }
      if (f.hasAttribute('data-v3-src')) {
        f.setAttribute('src', f.getAttribute('data-v3-src'));
        f.removeAttribute('data-v3-src');
      }
    }
    function release() {
      if (released) return;
      released = true;
      for (var i = 1; i < n; i++) unhold(frames[i]);
    }
    if (!lead || lead.complete) {
      release();
    } else {
      lead.addEventListener('load', release);
      lead.addEventListener('error', release);
      setTimeout(release, 4000);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-v3-pdp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    for (var j = 0; j < roots.length; j++) {
      revealCurrentColourway(roots[j]);
      keepFocusedChipClear(roots[j]);
      wireGallery(roots[j]);
    }
    wireStickyHandover();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
